import React, {Suspense} from 'react';

import {isMobile, isTablet} from 'react-device-detect';
import {Provider} from 'react-redux';
import * as Redux from 'redux';
import ReduxThunk from 'redux-thunk';
import reducer from '../redux';
import {
  mobilePossible,
  receiveMesseCartUpdate,
  receiveMetaUpdate,
  receiveMobileBigUpdate,
  receiveMobileMediumUpdate,
  receiveMobileUpdate,
  receiveShoppingCartUpdate
} from '../redux/actions';
import LoadingAnimation from './element/LoadingAnimation';

const PageContactBarkow = React.lazy(() => import('./page/contact/PageContactBarkow'));
const PageContactTeam = React.lazy(() => import('./page/contact/PageContactTeam'));
const PageContactDietz = React.lazy(() => import('./page/contact/PageContactDietz'));
const PageContactDuesing = React.lazy(() => import('./page/contact/PageContactDuesing'));
const PageContactGengenbach = React.lazy(() => import('./page/contact/PageContactGengenbach'));
const PageContactHagemann = React.lazy(() => import('./page/contact/PageContactHagemann'));
const PageContactKloempkes = React.lazy(() => import('./page/contact/PageContactKloempkes'));
const PageContactEbeling = React.lazy(() => import('./page/contact/PageContactEbeling'));
const PageContactLomberg = React.lazy(() => import('./page/contact/PageContactLomberg'));
const PageContactMdsi = React.lazy(() => import('./page/contact/PageContactMdsi'));
const PageContactNoerten = React.lazy(() => import('./page/contact/PageContactNoerten'));
const PageContactRoss = React.lazy(() => import('./page/contact/PageContactRoss'));
const PageContactTmu = React.lazy(() => import('./page/contact/PageContactTmu'));
const PageContactWagro = React.lazy(() => import('./page/contact/PageContactWagro'));
const PageContactNoris = React.lazy(() => import('./page/contact/PageContactNoris'));
const PageContactQtrado = React.lazy(() => import('./page/contact/PageContactQtrado'));
const PageContactGUNord = React.lazy(() => import('./page/contact/PageContactGUNord'));
const PageContactTrunk = React.lazy(() => import('./page/contact/PageContactTrunk'));
const PageContactMercura = React.lazy(() => import('./page/contact/PageContactMercura'));
const PageContactSteinhaus = React.lazy(() => import('./page/contact/PageContactSteinhaus'));
const PageContactWolters = React.lazy(() => import('./page/contact/PageContactWolters'));
const PageImpressumBarkow = React.lazy(() => import('./page/impressum/PageImpressumBarkow'));
const PageImpressumTeam = React.lazy(() => import('./page/impressum/PageImpressumTeam'));
const PageImpressumDietz = React.lazy(() => import('./page/impressum/PageImpressumDietz'));
const PageImpressumDuesing = React.lazy(() => import('./page/impressum/PageImpressumDuesing'));
const PageImpressumGengenbach = React.lazy(() => import('./page/impressum/PageImpressumGengenbach'));
const PageImpressumHagemann = React.lazy(() => import('./page/impressum/PageImpressumHagemann'));
const PageImpressumKloempkes = React.lazy(() => import('./page/impressum/PageImpressumKloempkes'));
const PageImpressumEbeling = React.lazy(() => import('./page/impressum/PageImpressumEbeling'));
const PageImpressumLomberg = React.lazy(() => import('./page/impressum/PageImpressumLomberg'));
const PageImpressumNoris = React.lazy(() => import('./page/impressum/PageImpressumNoris'));
const PageImpressumQtrado = React.lazy(() => import('./page/impressum/PageImpressumQtrado'));
const PageImpressumTrunk = React.lazy(() => import('./page/impressum/PageImpressumTrunk'));
const PageImpressumMercura = React.lazy(() => import('./page/impressum/PageImpressumMercura'));
const PageImpressumGUNord = React.lazy(() => import('./page/impressum/PageImpressumGUNord'));
const PageImpressumMdsi = React.lazy(() => import('./page/impressum/PageImpressumMdsi'));
const PageImpressumNoerten = React.lazy(() => import('./page/impressum/PageImpressumNoerten'));
const PageImpressumRoss = React.lazy(() => import('./page/impressum/PageImpressumRoss'));
const PageImpressumTmu = React.lazy(() => import('./page/impressum/PageImpressumTmu'));
const PageImpressumWagro = React.lazy(() => import('./page/impressum/PageImpressumWagro'));
const PageImpressumSteinhaus = React.lazy(() => import('./page/impressum/PageImpressumSteinhaus'));
const PageImpressumWolters = React.lazy(() => import('./page/impressum/PageImpressumWolters'));
const Page404 = React.lazy(() => import('./page/Page404'));
const Page403 = React.lazy(() => import('./page/Page403'));
const PageTrunkmeldung= React.lazy(() => import('./page/PageTrunkmeldung'));
const Page500 = React.lazy(() => import('./page/Page500'));
const PageBestseller = React.lazy(() => import('./page/PageBestseller'));
const PageBrand = React.lazy(() => import('./page/PageBrand'));
const PageCart = React.lazy(() => import('./page/PageCart'));
const PageCategory = React.lazy(() => import('./page/PageCategory'));
const PageVertriebsaktion = React.lazy(() => import('./page/PageVertriebsaktion'));
const PageHausmesse = React.lazy(() => import('./page/PageHausmesse'));
const PageHausmesseHersteller = React.lazy(() => import('./page/PageHausmesseHersteller'));
const PageCheckout = React.lazy(() => import('./page/PageCheckout'));
const PageCheckoutDelivery = React.lazy(() => import('./page/PageCheckoutDelivery'));
const PageCheckoutFinish = React.lazy(() => import('./page/PageCheckoutFinish'));
const PageCheckoutOverview = React.lazy(() => import('./page/PageCheckoutOverview'));
const PageCustomer = React.lazy(() => import('./page/PageCustomer'));
const PageRegistrierung = React.lazy(() => import('./page/PageRegistrierung'));
const PageCustomerChangeProfil = React.lazy(() => import('./page/PageCustomerChangeProfil'));
const PageCustomerInfo = React.lazy(() => import('./page/PageCustomerInfo'));
const PageCustomerInfoDetails = React.lazy(() => import('./page/PageCustomerInfoDetails'));
const PageCustomerInventur = React.lazy(() => import('./page/PageCustomerInventur'));
const PageCustomerInventuren = React.lazy(() => import('./page/PageCustomerInventuren'));
const PageCustomerRetourenerfassung = React.lazy(() => import('./page/PageCustomerRetourenerfassung'));
const PageCustomerList = React.lazy(() => import('./page/PageCustomerList'));
const PageCustomerLists = React.lazy(() => import('./page/PageCustomerLists'));
const PageCustomerMessages = React.lazy(() => import('./page/PageCustomerMessages'));
const PageCustomerSettings = React.lazy(() => import('./page/PageCustomerSettings'));
const PageCustomerOffenePosten = React.lazy(() => import('./page/PageCustomerOffenePosten'));
const PageCustomerOrders = React.lazy(() => import('./page/PageCustomerOrders'));
const PageCustomerPreislisten = React.lazy(() => import('./page/PageCustomerPreislisten'));
const PageCustomerProfile = React.lazy(() => import('./page/PageCustomerProfile'));
const PageCustomerLiefertagskalender = React.lazy(() => import('./page/PageCustomerLiefertagskalender'));
const PageInfo = React.lazy(() => import('./page/PageInfo'));
const PageInfoDetails = React.lazy(() => import('./page/PageInfoDetails'));
const PageLogin = React.lazy(() => import('./page/PageLogin'));
const PageAuthLogin = React.lazy(() => import('./page/PageAuthLogin'));
const PageAuthLoginConfirm = React.lazy(() => import('./page/PageAuthLoginConfirm'));
const PageGVLLogin = React.lazy(() => import('./page/PageGVLLogin'));
const PageNewProducts = React.lazy(() => import('./page/PageNewProducts'));
const PageProduct = React.lazy(() => import('./page/PageProduct'));
const PagePromotion = React.lazy(() => import('./page/PagePromotion'));
const PagePromotionOfTheWeek = React.lazy(() => import('./page/PagePromotionOfTheWeek'));
const PageResetPassword = React.lazy(() => import('./page/PageResetPassword'));
const PageSearch = React.lazy(() => import('./page/PageSearch'));
const PageSpecialOffer = React.lazy(() => import('./page/PageSpecialOffer'));
const PageStart = React.lazy(() => import('./page/PageStart'));
const PageTopliste = React.lazy(() => import('./page/PageTopliste'));
const PageToplisten = React.lazy(() => import('./page/PageToplisten'));
const PageWartungsarbeiten = React.lazy(() => import('./page/PageWartungsarbeiten'));
const PageRetourenDietz = React.lazy(() => import('./page/retoure/PageRetourenDietz'));
const Sitebody = React.lazy(() => import('./structure/site/Sitebody'));
const Sitefoot = React.lazy(() => import('./structure/site/Sitefoot'));
const SitefootStatic = React.lazy(() => import('./structure/site/SitefootStatic'));
const Sitehead = React.lazy(() => import('./structure/site/Sitehead'));
const SiteheadStatic = React.lazy(() => import('./structure/site/SiteheadStatic'));
const PageAgbBarkow = React.lazy(() => import('./page/agb/PageAgbBarkow'));
const PageAgbTeam = React.lazy(() => import('./page/agb/PageAgbTeam'));
const PageAgbSteinhaus = React.lazy(() => import('./page/agb/PageAgbSteinhaus'));
const PageAgbDietz = React.lazy(() => import('./page/agb/PageAgbDietz'));
const PageAgbDuesing = React.lazy(() => import('./page/agb/PageAgbDuesing'));
const PageAgbGengenbach = React.lazy(() => import('./page/agb/PageAgbGengenbach'));
const PageAgbHagemann = React.lazy(() => import('./page/agb/PageAgbHagemann'));
const PageAgbKloempkes = React.lazy(() => import('./page/agb/PageAgbKloempkes'));
const PageAgbEbeling = React.lazy(() => import('./page/agb/PageAgbEbeling'));
const PageAgbLomberg = React.lazy(() => import('./page/agb/PageAgbLomberg'));
const PageAgbMdsi = React.lazy(() => import('./page/agb/PageAgbMdsi'));
const PageAgbNoerten = React.lazy(() => import('./page/agb/PageAgbNoerten'));
const PageAgbRoss = React.lazy(() => import('./page/agb/PageAgbRoss'));
const PageAgbTmu = React.lazy(() => import( './page/agb/PageAgbTmu'));
const PageAgbWagro = React.lazy(() => import( './page/agb/PageAgbWagro'));
const PageAgbNoris = React.lazy(() => import('./page/agb/PageAgbNoris'));
const PageAgbQtrado = React.lazy(() => import('./page/agb/PageAgbQtrado'));
const PageAgbTrunk = React.lazy(() => import('./page/agb/PageAgbTrunk'));
const PageAgbMercura = React.lazy(() => import('./page/agb/PageAgbMercura'));
const PageAgbGUNord = React.lazy(() => import('./page/agb/PageAgbGUNord'));
const PageAgbWolters = React.lazy(() => import('./page/agb/PageAgbWolters'));
const PagePrivacyBarkow = React.lazy(() => import( './page/privacy/PagePrivacyBarkow'));
const PagePrivacyTeam = React.lazy(() => import( './page/privacy/PagePrivacyTeam'));
const PagePrivacySteinhaus = React.lazy(() => import( './page/privacy/PagePrivacySteinhaus'));
const PagePrivacyDietz = React.lazy(() => import('./page/privacy/PagePrivacyDietz'));
const PagePrivacyDuesing = React.lazy(() => import('./page/privacy/PagePrivacyDuesing'));
const PagePrivacyGengenbach = React.lazy(() => import( './page/privacy/PagePrivacyGengenbach'));
const PagePrivacyHagemann = React.lazy(() => import( './page/privacy/PagePrivacyHagemann'));
const PagePrivacyKloempkes = React.lazy(() => import( './page/privacy/PagePrivacyKloempkes'));
const PagePrivacyEbeling = React.lazy(() => import( './page/privacy/PagePrivacyEbeling'));
const PagePrivacyLomberg = React.lazy(() => import( './page/privacy/PagePrivacyLomberg'));
const PagePrivacyMdsi = React.lazy(() => import( './page/privacy/PagePrivacyMdsi'));
const PagePrivacyNoerten = React.lazy(() => import('./page/privacy/PagePrivacyNoerten'));
const PagePrivacyRoss = React.lazy(() => import( './page/privacy/PagePrivacyRoss'));
const PagePrivacyTmu = React.lazy(() => import( './page/privacy/PagePrivacyTmu'));
const PagePrivacyWagro = React.lazy(() => import( './page/privacy/PagePrivacyWagro'));
const PagePrivacyQtrado = React.lazy(() => import( './page/privacy/PagePrivacyQtrado'));
const PagePrivacyGUNord = React.lazy(() => import( './page/privacy/PagePrivacyGUNord'));
const PagePrivacyTrunk = React.lazy(() => import( './page/privacy/PagePrivacyTrunk'));
const PagePrivacyMercura = React.lazy(() => import( './page/privacy/PagePrivacyMercura'));
const PagePrivacyNoris = React.lazy(() => import( './page/privacy/PagePrivacyNoris'));
const PagePrivacyWolters = React.lazy(() => import( './page/privacy/PagePrivacyWolters'));

export const store = Redux.createStore(reducer, {}, Redux.applyMiddleware(ReduxThunk));
import Cookies from 'js-cookie';

class Shop extends React.PureComponent {
  constructor(props) {

    super(props);
    const clientdata = props.clientdata || {};
    const cart = props.cart || {};

    const messecart = props?.messecart || {};
    const meta = clientdata?.meta || {};

    //Neue Iphones haben ein Breite von über 1000 Pixeln
    let isMobile2 = meta.conf?.mobileOnlyByWidth ? false : isMobile;
    let isTablet2 = meta.conf?.mobileOnlyByWidth ? false : isTablet;
    const mobile = isMobile2 || window.matchMedia('screen and (max-width: 850px)').matches;
    const tablet = isTablet2 || window.matchMedia('screen and (max-width: 850px) and (min-width: 576px)').matches;

    let tmp = Cookies?.get('DesktopVersionOnMobile') || false;
    tmp = (tmp == 'true');
    const mobile_available = !!meta?.mobile && !tmp;

    store.dispatch(mobilePossible(mobile_available));
    store.dispatch(receiveMobileUpdate(mobile));
    store.dispatch(receiveMobileMediumUpdate(tablet));

    if (mobile && mobile_available) {
      document.body.classList.add('isMobile');
    } else {
      document.body.classList.add('isDesktop');
    }
    if (tablet && mobile_available) {
      document.body.classList.add('isTablet');
    }

    if (mobile_available && !tablet && !mobile) {
      store.dispatch(receiveMobileBigUpdate(window.matchMedia('screen and (max-width: 1170px) and (min-width: 851px)').matches));
    } else {
      store.dispatch(receiveMobileBigUpdate(window.matchMedia('screen and (max-width: 1170px) and (min-width: 0px)').matches));
    }

    store.dispatch(receiveMetaUpdate(meta));
    store.dispatch(receiveShoppingCartUpdate(cart));
    store.dispatch(receiveMesseCartUpdate(messecart));

      window.onresize = () => {
        document.body.classList.remove('isTablet');
        document.body.classList.remove('isDesktop');
        document.body.classList.remove('isMobile');
        let isMobile2 = meta.conf?.mobileOnlyByWidth ? false : isMobile;
        let isTablet2 = meta.conf?.mobileOnlyByWidth ? false : isTablet;
        const mobile = isMobile2 || window.matchMedia('screen and (max-width: 850px)').matches;
        const tablet = isTablet2 || window.matchMedia('screen and (max-width: 850px) and (min-width: 576px)').matches;
        store.dispatch(mobilePossible(mobile_available));
        store.dispatch(receiveMobileUpdate(mobile));
        store.dispatch(receiveMobileMediumUpdate(tablet));

        if (mobile && mobile_available) {
          document.body.classList.add('isMobile');
        } else {
          document.body.classList.add('isDesktop');
        }
        if (tablet && mobile_available) {
          document.body.classList.add('isTablet');
        }
        if (mobile_available && !tablet && !mobile) {
          store.dispatch(receiveMobileBigUpdate(window.matchMedia('screen and (max-width: 1170px) and (min-width: 851px)').matches));
        } else {
          store.dispatch(receiveMobileBigUpdate(window.matchMedia('screen and (max-width: 1170px) and (min-width: 0px)').matches));
        }

      };

  }

  componentDidMount() {
    // document.onscroll();
  }

  render() {
    const clientdata = this.props.clientdata || {};
    const meta2 = clientdata?.meta || {};
    const mobile_available = !!meta2?.mobile;


    let tmp = Cookies?.get('DesktopVersionOnMobile') || 'false';
    tmp = (tmp == 'true');

    if (mobile_available && tmp) {
      document.getElementsByTagName('html')[0].classList.remove('mobile-available');
      document.getElementsByTagName('html')[0].classList.add('noMobile');
    }else if(mobile_available){
       document.getElementsByTagName('html')[0].classList.remove('noMobile');
      document.getElementsByTagName('html')[0].classList.add('mobile-available');
    }

    const meta = clientdata?.meta || {};
    const is_logged_in = !!meta?.login;
    const force_login = !!meta?.force_login;
    const config = clientdata.config || {};

    //Qtrado gedöns
    if((window.location.href).indexOf("tcqtrado.forlinq.de") == -1
    && clientdata.meta.conf.cssCompletePath){
      clientdata.meta.conf.cssCompletePath=false;
    }

    const dontShowHeaderFooter = clientdata?.page ==  "authLogin" || clientdata?.page == "authLoginConfirm";
    if (clientdata.errorCode === '500') {
      return <div className={'_Shop'}>
        <SiteheadStatic/>
        <Sitebody>
          <PageWartungsarbeiten/>
        </Sitebody>
        <SitefootStatic/>
      </div>;
    } else {
      // store.subscribe(() => {
      //   console.log('** STORE **', store.getState());
      // });

      let page;
      const activeFooter = false;


      if (force_login && !is_logged_in &&
        clientdata.page !== 'gvllogin'
           &&
        !['impressum',
          'privacy',
          'agb',
          'reset_password',
          'contact',
          'retouren',
          '500',
          '404',
          '403', 'wartungsarbeiten', 'registrierung', 'authLogin'].includes(clientdata.page)) {
        page = <PageLogin {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
      } else {
        switch (clientdata.page) {
          case '500':
            page = <Page500/>;
            break;
          case '404':
            page = <Page404/>;
            break;
          case '403':
            page = <Page403/>;
            break;
          case 'category':
            page = <PageCategory {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'vertriebsaktion':
            page = <PageVertriebsaktion {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'hausmesse':
            page = <PageHausmesse {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'hausmesse_hersteller':
            page = <PageHausmesseHersteller {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'search':
            page = <PageSearch {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'brand':
            page = <PageBrand {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'promotion':
            page = <PagePromotion {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'promotion-of-the-week':
            page = <PagePromotionOfTheWeek {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'special-offers':
            page = <PageSpecialOffer {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'bestseller':
            page = <PageBestseller {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'new-products':
            page = <PageNewProducts {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'product':
            page = <PageProduct {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'contact':
            switch (clientdata.design) {
              case 'tmu':
                page = <PageContactTmu {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'ross':
                page = <PageContactRoss {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'dietz':
                page = <PageContactDietz {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'duesing':
                page = <PageContactDuesing {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'hagemann':
                page = <PageContactHagemann {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'gengenbach':
                page = <PageContactGengenbach {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'wagro':
                page = <PageContactWagro {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'barkow':
                page = <PageContactBarkow {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'team':
                page = <PageContactTeam {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'kloempkes':
                page = <PageContactKloempkes {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'ebeling':
                page = <PageContactEbeling {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'lomberg':
                page = <PageContactLomberg {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'noerten':
                page = <PageContactNoerten {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'noris':
                page = <PageContactNoris {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'qtrado':
                page = <PageContactQtrado {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'gunord':
                page = <PageContactGUNord {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'trunk':
                page = <PageContactTrunk {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'mercura':
                page = <PageContactMercura {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'steinhaus':
                page = <PageContactSteinhaus {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'wolters':
                page = <PageContactWolters {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
              case 'mdsi':
              default:
                page = <PageContactMdsi {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
                break;
            }
            break;
          case 'privacy':
            switch (clientdata.design) {
              case 'tmu':
                page = <PagePrivacyTmu {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'dietz':
                page = <PagePrivacyDietz {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'duesing':
                page = <PagePrivacyDuesing {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'ross':
                page = <PagePrivacyRoss {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'hagemann':
                page = <PagePrivacyHagemann {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'gengenbach':
                page = <PagePrivacyGengenbach {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'wagro':
                page = <PagePrivacyWagro {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'kloempkes':
                page = <PagePrivacyKloempkes {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'ebeling':
                page = <PagePrivacyEbeling {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'lomberg':
                page = <PagePrivacyLomberg {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'noerten':
                page = <PagePrivacyNoerten {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'barkow':
                page = <PagePrivacyBarkow {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'team':
                page = <PagePrivacyTeam {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'noris':
                page = <PagePrivacyNoris {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'qtrado':
                page = <PagePrivacyQtrado {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'gunord':
                page = <PagePrivacyGUNord {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'trunk':
                page = <PagePrivacyTrunk {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'mercura':
                page = <PagePrivacyMercura {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'steinhaus':
                page = <PagePrivacySteinhaus {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'wolters':
                page = <PagePrivacyWolters {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'mdsi':
              default:
                page = <PagePrivacyMdsi {...clientdata.sitebody} config={config.body}/>;
                break;
            }
            break;
          case 'cart':
            page = <PageCart {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'checkout':
            page = <PageCheckout {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'checkout_delivery':
            page = <PageCheckoutDelivery {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'checkout_overview':
            page = <PageCheckoutOverview {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}
                                         agbBezeichnung={clientdata.agbBezeichnung}/>;
            break;
          case 'checkout_finish':
            page = <PageCheckoutFinish {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'registrierung':
            page = <PageRegistrierung {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'impressum':

            switch (clientdata.design) {
              case 'tmu':
                page = <PageImpressumTmu {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'ross':
                page = <PageImpressumRoss {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'dietz':
                page = <PageImpressumDietz {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'duesing':
                page = <PageImpressumDuesing {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'kloempkes':
                page = <PageImpressumKloempkes {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'ebeling':
                page = <PageImpressumEbeling {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'lomberg':
                page = <PageImpressumLomberg {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'noerten':
                page = <PageImpressumNoerten {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'hagemann':
                page = <PageImpressumHagemann {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'gengenbach':
                page = <PageImpressumGengenbach {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'wagro':
                page = <PageImpressumWagro {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'barkow':
                page = <PageImpressumBarkow {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'team':
                page = <PageImpressumTeam {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'noris':
                page = <PageImpressumNoris{...clientdata.sitebody} config={config.body}/>;
                break;
              case 'qtrado':
                page = <PageImpressumQtrado {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'trunk':
                page = <PageImpressumTrunk {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'mercura':
                page = <PageImpressumMercura {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'gunord':
                page = <PageImpressumGUNord{...clientdata.sitebody} config={config.body}/>;
                break;
              case 'steinhaus':
                page = <PageImpressumSteinhaus {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'wolters':
                page = <PageImpressumWolters {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'mdsi':
              default:
                page = <PageImpressumMdsi {...clientdata.sitebody} config={config.body}/>;
                break;
            }
            break;
          case 'agb':
            switch (clientdata.design) {
              case 'tmu':
                page = <PageAgbTmu {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'ross':
                page = <PageAgbRoss {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'dietz':
                page = <PageAgbDietz {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'duesing':
                page = <PageAgbDuesing {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'hagemann':
                page = <PageAgbHagemann {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'gengenbach':
                page = <PageAgbGengenbach {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'wagro':
                page = <PageAgbWagro {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'barkow':
                page = <PageAgbBarkow {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'team':
                page = <PageAgbTeam {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'kloempkes':
                page = <PageAgbKloempkes {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'ebeling':
                page = <PageAgbEbeling {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'lomberg':
                page = <PageAgbLomberg {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'noerten':
                page = <PageAgbNoerten {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'noris':
                page = <PageAgbNoris {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'qtrado':
                page = <PageAgbQtrado {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'trunk':
                page = <PageAgbTrunk {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'mercura':
                page = <PageAgbMercura {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'gunord':
                page = <PageAgbGUNord {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'steinhaus':
                page = <PageAgbSteinhaus {...clientdata.sitebody} config={config.body}/>;
                break;
              case 'mdsi':
              default:
                page = <PageAgbMdsi {...clientdata.sitebody} config={config.body}/>;
                break;
            }
            break;
          case 'retouren':
            switch (clientdata.design) {
              default:
                page = <Page404/>;
                break;
            }
            break;
          case 'info':
            page = <PageInfo {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'customerinfo':
            page = <PageCustomerInfo {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'info_details':
            page = <PageInfoDetails {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'customerinfo_details':
            page = <PageCustomerInfoDetails {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'login':
            page = <PageLogin {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'authLogin':
            page = <PageAuthLogin {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'authLoginConfirm':
            page = <PageAuthLoginConfirm {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'gvllogin':
            page = <PageGVLLogin {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'reset_password':
            page = <PageResetPassword {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer':
            page = <PageCustomer {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'customer_profile':
            page = <PageCustomerProfile {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_liefertagskalender':
            page = <PageCustomerLiefertagskalender {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_orders':
            page = <PageCustomerOrders {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'customer_lists':
            page = <PageCustomerLists {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_list':
            page = <PageCustomerList {...clientdata.sitebody} config={config.body}/>;
            break;
          case 'customer_messages':
            page = <PageCustomerMessages {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_settings':
            page = <PageCustomerSettings {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_offene_posten':
            page = <PageCustomerOffenePosten {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_change_profil':
            page = <PageCustomerChangeProfil {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_inventur':
            page = <PageCustomerInventur {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_retourenerfassung':
            page =
              <PageCustomerRetourenerfassung {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            page =
              <PageCustomerRetourenerfassung {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_inventuren':
            page = <PageCustomerInventuren {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'customer_preislisten':
            page = <PageCustomerPreislisten {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'toplisten':
            page = <PageToplisten {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'topliste':
            page = <PageTopliste {...clientdata.sitebody} config={config.body} csrf={clientdata.csrf}/>;
            break;
          case 'wartungsarbeiten':
            page = <PageWartungsarbeiten {...clientdata.sitebody} config={config.body}
                                         message={clientdata.maintenance_message}/>;
            break;
          case 'start':
          default:
            page = <PageStart {...clientdata.sitebody} config={config.body}/>;
            break;
        }
      }


      if(meta.conf?.trunkMeldung){
        page = <PageTrunkmeldung />;
      }

      return <Provider store={store}>
        <div className={'_Shop' + (isTablet ? ' tablet' : isMobile ? ' mobile' : ' desktop')}
             id={'Shop'}
        >
          <Suspense fallback={<LoadingAnimation/>}>
            {!dontShowHeaderFooter ? <Sitehead maintenance={clientdata.maintenance}
                      login={is_logged_in} {...clientdata.sitehead}
                      hasInfo={clientdata.sitebody?.hasInfo}
                      config={config.head}
                   hausmesse={clientdata?.sitebody?.hausmesse}
            />: null}
            <Sitebody onClick={() => null} hasInfo={clientdata.sitebody?.hasInfo} {...clientdata.sitebody}>
              {page}
            </Sitebody>
            {!dontShowHeaderFooter ? <Sitefoot footerActive={activeFooter} maintenance={clientdata.maintenance} {...clientdata.sitefoot}
                      config={config.foot} design={clientdata.design} hidden={dontShowHeaderFooter}/>: null}
            <div id='modalTarget'/>
          </Suspense>
        </div>
      </Provider>;
    }
  }
}

export default Shop;
